import { useEffect } from 'react';

import { markChartDrawn } from './chart-request-registry';

/**
 * Stamps the moment a chart card stops loading, for the Data Inspector's
 * timeline. Runs from `ChartFallback`, the one place every card's status
 * passes through, so no provider has to know the inspector exists.
 */
export const useReportChartDrawn = (
  chartItemId: string | undefined,
  isLoading: boolean
) => {
  useEffect(() => {
    if (chartItemId === undefined || isLoading) return;
    markChartDrawn(chartItemId, performance.now());
  }, [chartItemId, isLoading]);
};
